// TODO: این نقش‌ها بعداً از توکن/API واقعی احراز هویت خوانده شوند.
// فعلاً برای تست، نقش فعلی در localStorage نگه‌داری می‌شود و از هدر قابل تغییر است.

export enum UserRole {
  SUPER_ADMIN = "superadmin",
  ADMIN = "admin",
  SALES_EXPERT = "sales_expert",
  ACCOUNTING_EXPERT = "accounting_expert",
  SALES_MANAGER = "sales_manager",
}

export const ROLE_LABELS: Record<UserRole, string> = {
  [UserRole.SUPER_ADMIN]: "سوپرادمین",
  [UserRole.ADMIN]: "ادمین",
  [UserRole.SALES_EXPERT]: "کارشناس فروش",
  [UserRole.ACCOUNTING_EXPERT]: "کارشناس حسابداری",
  [UserRole.SALES_MANAGER]: "مدیر فروش",
};

const ROLE_STORAGE_KEY = "mock_user_role";

export const getCurrentUserRole = (): UserRole => {
  const stored = localStorage.getItem(ROLE_STORAGE_KEY) as UserRole | null;
  if (stored && Object.values(UserRole).includes(stored)) {
    return stored;
  }
  return UserRole.SUPER_ADMIN;
};

export const setCurrentUserRole = (role: UserRole) => {
  localStorage.setItem(ROLE_STORAGE_KEY, role);
  window.dispatchEvent(new Event("mock-role-change"));
};

export const hasFullAccess = (role: UserRole) =>
  role === UserRole.SUPER_ADMIN || role === UserRole.ADMIN;

export const canCreateProforma = (role: UserRole) =>
  hasFullAccess(role) || role === UserRole.SALES_EXPERT;

export const canRegisterPayment = (role: UserRole) =>
  hasFullAccess(role) || role === UserRole.SALES_EXPERT;

export const canApproveAccounting = (role: UserRole) =>
  hasFullAccess(role) || role === UserRole.ACCOUNTING_EXPERT;

export const canApproveSalesManager = (role: UserRole) =>
  hasFullAccess(role) || role === UserRole.SALES_MANAGER;

export const canEditPayment = (
  role: UserRole,
  payment: { accountantApproved: boolean }
) => {
  if (hasFullAccess(role)) return true;
  if (role === UserRole.SALES_EXPERT) return !payment.accountantApproved;
  return false;
};

export const canEditProformaInvoice = (
  role: UserRole,
  invoice: { status: string; payments: { accountantApproved: boolean }[] }
) => {
  if (hasFullAccess(role)) return true;
  if (role === UserRole.SALES_EXPERT) {
    return (
      invoice.status === "پیش فاکتور" &&
      !invoice.payments.some((p) => p.accountantApproved)
    );
  }
  return false;
};

// کارشناس فروش فقط پیش‌فاکتورهای خودش را می‌بیند
export const canViewInvoice = (
  role: UserRole,
  invoice: { registeredBy: string },
  currentUsername: string
) => {
  if (role === UserRole.SALES_EXPERT) {
    return invoice.registeredBy === currentUsername;
  }
  return true;
};
